import React from 'react'
import { colors, borderRadius } from '../../styles/tokens'
import { formatFullDate, formatPrice, getBlockIcon } from '../../utils/formatters'
import BlockDetails from './BlockDetails'

/**
 * Preview de um bloco individual
 * 
 * Single Responsibility: Renderiza um bloco com título, data, preço e detalhes
 */
export default function BlockPreview({ block }) {
  return (
    <div style={{
      padding: '1rem',
      backgroundColor: colors.background,
      borderRadius: borderRadius.md,
      border: `1px solid ${colors.border}`
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginBottom: '0.5rem'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: '1.25rem' }}>{getBlockIcon(block.type)}</span>
          <span style={{ fontWeight: 500, color: colors.text.primary }}>
            {block.title}
          </span>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '0.8rem', color: colors.text.secondary }}>
            {formatFullDate(block.date)}
          </div>
          {block.price > 0 && (
            <div style={{ fontSize: '0.85rem', fontWeight: 500, color: colors.primary }}>
              {formatPrice(block.price)}
            </div>
          )}
        </div>
      </div>
      <BlockDetails block={block} />
    </div>
  )
}
